export const SUPABASE_ERRORS = [
  "invalid_credentials",
  "email_not_confirmed",
  "over_email_send_rate_limit",
];
